<mat-tab-group (selectedTabChange)="onTabChange($event)">
  <mat-tab label="Basic Information">
    <section class="basic-info-section">
      <app-profile-manage></app-profile-manage>
    </section>
  </mat-tab>
  <mat-tab label="Driver License Update">
    <section class="driver-license-section">
      <app-document-upload
        [metadata]="{
          title: 'Drivers License',
          description: 'Upload your drivers license.'
        }"
        [fields]="[
          {
            label: 'Upload Front of Drivers License',
            type: 'image',
            name: 'driversLicenseFront',
            required: true,
            helpText: 'Upload the front side of your drivers license',
            validationMessage: 'This field is required.'
          },
          {
            label: 'Upload Back of Drivers License',
            type: 'image',
            name: 'driversLicenseBack',
            required: true,
            helpText: 'Upload the back side of your drivers license',
            validationMessage: 'This field is required.'
          }
        ]"
        (uploadComplete)="onUploadComplete($event)"
      ></app-document-upload>
    </section>
  </mat-tab>
  <mat-tab label="Insurance Information">
    <section class="insurance-section">
      <app-insurance-information></app-insurance-information>
    </section>
  </mat-tab>
</mat-tab-group>
